module.exports = __webpack_public_path__ + "static/img/contract_step_2.7b88118.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contract_step_2.png
// module id = yFJN
// module chunks = 1